import "./Comment.scss"
import UserDetail from "components/ui/UserDetail/UserDetail";
import Button from "components/ui/Button/Button";
import { ReactComponent as IconPencil } from "assets/images/icons/pencil-square-primary.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/trashfull.svg";
import HTMLContainer from "components/ui/HTML/HTMLContainer";
import { useDialog } from "context/DialogContext";
import CommentCreateUpdate from "features/comments/components/CommentCreateUpdate";
import CommentDelete from "features/comments/components/CommentDelete";
import { useAccount } from "context/AccountContext";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import ButtonLike from "features/likes/components/ButtonLike/ButtonLike";
import { useState } from "react";
import ParticipationStatusBar from "components/ui/ParticipationStatusBar/ParticipationStatusBar";

const Comment = ({ data, isReply = false, onChanged }) => {
  const [likeCount, setLikeCount] = useState(0);

  const { showDialog } = useDialog();
  const { user } = useAccount();
  const isDeleted = data.field_deleted === '1';

  const showCommentDialog = (commentId = null, parentCommentId = null) => {
    showDialog(<CommentCreateUpdate id={ commentId }
                                    entityId={ parseInt(data.nid) }
                                    parentId={ parentCommentId }
                                    onCompleted={ onChanged }/>)
  }

  const wrapperClasses = [
    `comment`,
    isReply ? `comment--reply` : `comment--parent`,
  ];

  const contentClasses = [
    `comment__content`,
    isReply ? `comment__content--reply` : ``,
  ];

  return (
    <div className={ wrapperClasses.join(` `) }>
      <div className={ contentClasses.join(` `) }>
        <div className={ `comment__user` }>
          <div className={ `comment__header` }>
            <UserDetail image={ data.field_profile_photo }
                        username={ data.author }
                        subtext={ data.created }
                        url={ data.profile_url }/>
            <ButtonLike
              entityId={ parseInt(data.cid) }
              entityType={ `comment` }
              onReceivedCount={ (count) => setLikeCount(count) }
            />
          </div>
        </div>

        <div className={ `comment__comment` }>
          {
            !isDeleted ?
              <>
                <HTMLContainer value={ data.comment_body }/>
                {
                  data.field_comment_image &&
                  <div className={ 'comment__image' }>
                    <ResponsiveImage value={ data.field_comment_image }/>
                  </div>
                }
              </>
              :
              <strong>- verwijderd -</strong>
          }

          {
            user.id === parseInt(data.uid) && !isDeleted &&
            <div className={ `comment__controls` }>
              <Button variant={ `ghost` }
                      onClick={ () => showCommentDialog(parseInt(data.cid)) }
                      className={ `button--small` }>
                <IconPencil/>
                Bewerken
              </Button>

              <Button variant={ `ghost` }
                      onClick={ () => showDialog(<CommentDelete id={ data.cid } onCompleted={ onChanged }/>) }
                      className={ `button--small` }>
                <IconTrash/>
                Verwijderen
              </Button>
            </div>
          }

          <ParticipationStatusBar
            likeCount={ likeCount }
            onReply={ !isDeleted && !isReply ? () => showCommentDialog(null, parseInt(data.cid)) : undefined }
            variant={ `teaser` }
          />
        </div>
      </div>
    </div>
  );
}

export default Comment;
